import {
  BaSeBreakpointContext,
  BaSeIcon,
  BaSeLoadingPage,
  BaSeParagraph,
  BaSeSmall1,
  BaSeStepper,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useAnswerController } from '../../../../hooks/controllers/answer-controller';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useModuleController } from '../../../../hooks/controllers/module-public-controller';
import { LayoutCandidate } from '../../components/layout-candidate';
import { isFinalizedStateMap } from '../about-course/about-course';
import {
  Container,
  ImageResult,
  ImageWrapper,
  ResultBoxMessageWrapper,
  ResultTextMessagetWrapper,
  ResultTextSubTitle,
  ResultTextTitle,
  ResultWrapper,
  StepWrapper,
  TextLink,
} from './result-content-styled';

const mapStepTitle = {
  1: { normal: 'Conheça o Empretec', responsive: 'O Empretec' },
  2: { normal: 'Dados básicos', responsive: 'Dados básicos' },
  3: { normal: 'Entrevista de seleção', responsive: 'Entrevista' },
};

const mapTitles = {
  1: {
    title: 'Em processamento',
    subTitle:
      'Sua entrevista foi enviada e será analisada. Aguarde as novidades sobre sua inscrição em seu e-mail.',
  },
  2: {
    title: 'Sua entrevista não foi enviada',
    subTitle:
      'Mas não se preocupe, suas respostas estão salvas. Às vezes isso acontece, tente novamente em alguns instantes.',
  },
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const ResultContent = () => {
  const breakpointController = React.useContext(BaSeBreakpointContext);
  const { findInterviewByUserAuth, findInterviewByIdPublic } =
    useInterviewController();
  const [interview, setInterview] = React.useState();
  const [isSuccess, setIsSucess] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  const { navigateTo, getRouteParam } = Sebrae.useSebraeRouter();

  const { sendAnswerInterview, getAnswersByInterview } = useAnswerController();

  const { getSettingsModule } = useModuleController();
  const { hasRole } = Sebrae.useAuth();

  const [settingsModule, setSettingsModule] = React.useState();

  const setModulesToConfig = React.useCallback(
    (id) => {
      getSettingsModule(id)
        .then((settings) => {
          setSettingsModule(settings);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [getSettingsModule],
  );

  const steps = React.useMemo(
    () => [
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: getStepTitle(1, breakpointController),
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: getStepTitle(2, breakpointController),
      },
      {
        isCompleted: true,
        withError: !isSuccess,
        isClickable: false,
        title: getStepTitle(3, breakpointController),
      },
    ],
    [breakpointController, isSuccess],
  );
  const idInterview = getRouteParam('id');
  React.useEffect(() => {
    setLoading(true);
    findInterviewByIdPublic(Number(idInterview))
      .then((result) => {
        setInterview(result);

        setModulesToConfig(result.moduleId);
        setIsSucess(isFinalizedStateMap[result?.statusCompletingInterview]);
        setLoading(false);
      })
      .catch((err) => console.log('err', err))
      .finally(setLoading(false));
  }, [
    findInterviewByIdPublic,
    setModulesToConfig,
    findInterviewByUserAuth,
    idInterview,
  ]);

  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const handleVoltar = React.useCallback(() => {
    if (Number(idInterview) !== undefined && hasRole('ADMINISTRADOR')) {
      navigateTo(`${getUrl()}/candidato/sobre-curso/id/${Number(idInterview)}`);
      return;
    }
    navigateTo(`${getUrl()}/candidato/sobre-curso`, {
      keepQueryString: true,
    });
  }, [getUrl, hasRole, idInterview, navigateTo]);

  return (
    <LayoutCandidate settings={settingsModule}>
      {loading ? (
        <Container>
          <BaSeLoadingPage></BaSeLoadingPage>
        </Container>
      ) : (
        <Container>
          <ResultWrapper>
            <StepWrapper>
              <BaSeStepper
                steps={steps}
                onStepChange={() => {}}
                currentStep={3}
                activeWithErrorColor={BaSeTheme.colors.feedbackInterface.erro45}
                activeColor={BaSeTheme.colors.feedbackInterface.sucesso}
                completedColor={BaSeTheme.colors.feedbackInterface.sucesso70}
                orientation={'horizontal'}
              />
            </StepWrapper>
            <ResultBoxMessageWrapper isSuccess={isSuccess}>
              <BaSeIcon
                color={BaSeTheme.colors.defaultColors.white}
                description={isSuccess ? 'Success' : 'Error'}
                name={getIcon(isSuccess)}
                size={32}
              />
              <ResultTextMessagetWrapper>
                <ResultTextTitle>
                  <BaSeParagraph
                    isBold
                    color={BaSeTheme.colors.defaultColors.white}
                  >
                    {getTitle(isSuccess).title}
                  </BaSeParagraph>
                </ResultTextTitle>
                <ResultTextSubTitle>
                  <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
                    {getTitle(isSuccess).subTitle}
                  </BaSeParagraph>
                  {!isSuccess && (
                    <div style={{ display: 'flex', gap: 12 }}>
                      <TextLink>
                        <BaSeSmall1
                          isBold
                          color={BaSeTheme.colors.defaultColors.white}
                          onClick={handleVoltar}
                        >
                          Voltar
                        </BaSeSmall1>
                      </TextLink>

                      <TextLink>
                        <BaSeSmall1
                          isBold
                          color={BaSeTheme.colors.defaultColors.white}
                          onClick={() => {
                            findInterviewByIdPublic(interview.id).then(
                              (response) => {
                                getAnswersByInterview(response?.id)
                                  .then((result) => {
                                    sendAnswerInterview(
                                      {
                                        idInterview: response?.id,
                                        answers: result,
                                      },
                                      interview.moduleId,
                                    )
                                      .then(() => {
                                        navigateTo('/candidato/resultado', {
                                          keepQueryString: true,
                                        });
                                      })
                                      .catch((error) => {
                                        console.log(
                                          'Falha ao reenviar entrevista para analise',
                                          error,
                                          interview,
                                        );
                                      });
                                  })
                                  .catch((error) => {
                                    console.log(
                                      'Falha ao reenviar entrevista para analise',
                                      error,
                                      interview,
                                    );
                                  });
                              },
                            );
                          }}
                        >
                          Enviar a inscrição novamente.
                        </BaSeSmall1>
                      </TextLink>
                    </div>
                  )}
                </ResultTextSubTitle>
              </ResultTextMessagetWrapper>
            </ResultBoxMessageWrapper>

            <ImageWrapper>
              <ImageResult isSuccess={isSuccess} />
            </ImageWrapper>
          </ResultWrapper>
        </Container>
      )}
    </LayoutCandidate>
  );
};

function getTitle(success) {
  return success ? mapTitles[1] : mapTitles[2];
}

function getIcon(success) {
  return success ? 'clock-three' : 'exclamation-octagon';
}

function getStepTitle(step, breakpointController) {
  const isLargeDisplay =
    breakpointController.inDesktop ||
    breakpointController.inDesktopLarge ||
    breakpointController.inTablet;

  return isLargeDisplay
    ? mapStepTitle[step].normal
    : mapStepTitle[step].responsive;
}
